import React, { useState, useEffect } from 'react';
import { Drawer, Box, Typography, Divider, Grow } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import { getImages } from './SideMenuApi';
import BoxMenu from './BoxMenu';
import BoxOptionsImage from './BoxOptionsImage';
import useStyle from './style';
import BoxOptionsColors from './BoxOptionColors/BoxOptionsColors';

export default function SideMenu({ open, toggleDrawer, setBackgroundImage }) {
  const classes = useStyle();
  const [photos, setphotos] = useState([]);
  const [openImageOptions, setOpenImageOptions] = useState(false);
  const [openColorOptins, setOpenColorOptions] = useState(false);

  const closeDrawer = () => {
    toggleDrawer();
    setOpenImageOptions(false);
    setOpenColorOptions(false);
  };

  useEffect(() => {
    getImages().then((photos) => {
      setphotos(photos);
    });
  }, [openImageOptions, openColorOptins]);

  return (
    <div>
      <Drawer
        onClose={closeDrawer}
        open={open}
        anchor="right"
        className={classes.drawer}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <Box className={classes.titleContainer}>
          <Typography className={classes.title}>Change Background</Typography>
          <ClearIcon onClick={closeDrawer} />
        </Box>
        <Divider />

        <BoxMenu
          setOpenOptionImages={setOpenImageOptions}
          setOpenColorOptions={setOpenColorOptions}
        />
        {openImageOptions && !openColorOptins ? (
          <BoxOptionsImage
            display={openImageOptions}
            photos={photos}
            setBackgroundImage={setBackgroundImage}
          />
        ) : (
          <BoxOptionsColors
            setBackgroundImage={setBackgroundImage}
            display={openColorOptins}
          />
        )}
      </Drawer>
    </div>
  );
}
